import { Component, EventEmitter, Input, OnChanges, OnInit, Output } from "@angular/core";
import { DataSheetIP, DatasheetNumbers, SalesOrder, UserType } from "../../../shared/misc-classes";
import { DataService } from "../../../shared/dataservice.service";


@Component({
  selector: 'add-datasheet-popup',
  templateUrl: 'add-datasheet-popup.html',
})
export class AddDatasheetPopup implements OnInit, OnChanges {
  //disableSelect = new FormControl(false);
  @Input() soObj: SalesOrder;
  @Input() DataSheetList:Array<DatasheetNumbers>;
  @Output() createNewDataSheet: EventEmitter<any> = new EventEmitter();
  @Input() soLock: boolean;
  inputDisableMessage:string = '';

  availableDataSheetList:Array<DatasheetNumbers>;
  disableForm: boolean=false;
  accessLevel: Array<UserType> = [];

  selectedDSNumId:string;
  selectedDStyId:string = "UG ZS1";
  constructor(public _dataService: DataService
    //public dialogRef: MatDialogRef<AddSuborderPopup>,
    //@Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  ngOnInit(){
    
  }
  ngOnChanges(){

  this.accessLevel.push(UserType.SUPER_ADMIN, UserType.MARKETING, UserType.HOD_MARKETING); // ONLY these users can edit Datasheets in SO Level
  
  this.availableDataSheetList = this.getAvailableDataSheetList();
    if(this.availableDataSheetList.length > 0){
      if(this.selectedDSNumId == null){
          this.selectedDSNumId = this.availableDataSheetList[0].datasheetNumbersId;
      }
      else{
        var isPrevItemFound:boolean = false;
        for(var i=0;i<this.availableDataSheetList.length;i++){
          if(this.selectedDSNumId == this.availableDataSheetList[i].datasheetNumbersId){
            isPrevItemFound = true;
            break;
          }
        }

        if(isPrevItemFound == false){
          this.selectedDSNumId = this.availableDataSheetList[0].datasheetNumbersId;
        }
      }
      
    }
    this.disableForm=true;
    if (this.issoLockObtained == false){
      this.inputDisableMessage= "You can't Edit";
    }
    if(this.availableDataSheetList.length == 0 ){
      this.inputDisableMessage= "Data Sheet Limit Reached";
    }
    else if (this.accessLevel.includes(this._dataService.userType) == false) {
      this.inputDisableMessage = "You don't have EDIT ACCESS.";
    }
    else{
      this.disableForm =false
    }
  }
  get issoLockObtained(): boolean{
    return this.soLock;
  }

  getAvailableDataSheetList():Array<DatasheetNumbers>{
    return this._dataService.datasheetNumbers.filter((_subOrdNum:DatasheetNumbers) => {
      return this.DataSheetList.indexOf(_subOrdNum) < 0;
    });
  }
  addNewDataSheet(){
    if(this.selectedDSNumId && this.selectedDStyId){
      this.createNewDataSheet.emit({"selSubNumId":this.selectedDSNumId,"copySubNumId":this.selectedDStyId});
    }
  }

}

